class Exception extends Error {
    constructor(message, scope, internalError) {
        super(message);
        this.scope = scope;
        this.internalError = internalError;
    }
}

module.exports = Exception;
